import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center q-mt-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_input, _mergeProps({
      modelValue: _ctx.content,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.content) = $event)),
      type: "textarea",
      placeholder: "Add a note...",
      loading: _ctx.isLoading
    }, _ctx.$attrs, {
      onKeydown: _withKeys(_withModifiers(_ctx.add, ["prevent"]), ["enter"])
    }), null, 16, ["modelValue", "loading", "onKeydown"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_btn, {
        icon: "fa fa-plus",
        label: "Save Note",
        disable: !_ctx.content,
        onClick: _ctx.add
      }, null, 8, ["disable", "onClick"])
    ])
  ]))
}